import { atomWithStorage } from 'jotai/utils';
import { useAtom } from 'jotai';

export interface NSFWSettings {
  mature: boolean;
  explicit: boolean;
  blur: boolean;
  confirmed18: boolean;
}

const DEFAULT_SETTINGS: NSFWSettings = {
  mature: true,
  explicit: true,
  blur: true,
  confirmed18: false
};

export const nsfwSettingsAtom = atomWithStorage<NSFWSettings>('nsfw-settings', DEFAULT_SETTINGS);

export function useNSFWSettings() {
  const [settings, setSettings] = useAtom(nsfwSettingsAtom);

  const updateSettings = (newSettings: Partial<NSFWSettings>) => {
    setSettings(prevSettings => ({
      ...prevSettings,
      ...newSettings
    }));
  };

  return {
    settings,
    updateSettings
  };
} 